import * as React from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { WorkflowWebhooksEmpty, WorkflowWebhookMissing } from 'ui/illustrations';
import { spacing, colors } from 'ui/theme';
import { body1, heading4 } from 'ui/theme/typography';

const EmptyStateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${pxToRem(400)};
`;

const EmptyStateContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${pxToRem(461)};
`;

const MainStyling = styled.div`
  margin-bottom: ${spacing.half};
  ${heading4};
`;

const CaptionStyling = styled.div`
  text-align: center;
  ${body1};
  color: ${colors.textSecondary};
`;

type ImageProps = {
  height?: number;
  width?: number;
};
interface EmptyStateGeneratorProps {
  Image: React.ComponentType<React.PropsWithChildren<ImageProps>>;
  mainText: string;
  id: string;
  children: React.ReactNode;
}

const EmptyStateGenerator = ({ Image, mainText, id, children }: EmptyStateGeneratorProps) => (
  <EmptyStateWrapper data-test={id}>
    <EmptyStateContent>
      <Image />
      <MainStyling>{mainText}</MainStyling>
      <CaptionStyling>{children}</CaptionStyling>
    </EmptyStateContent>
  </EmptyStateWrapper>
);

export const GeneralEmptyState = (): JSX.Element => (
  <EmptyStateGenerator
    Image={WorkflowWebhooksEmpty}
    mainText="You'll find your journey webhooks here"
    id="workflow-webhook-index-empty-state"
  >
    {'To send data from your journeys to an external server, add a new webhook.'}
  </EmptyStateGenerator>
);

export const NoResults = (): JSX.Element => (
  <EmptyStateGenerator
    Image={WorkflowWebhookMissing}
    mainText="No matching webhooks"
    id="workflow-webhook-index-no-results"
  >
    {'Try searching by a different name, ID, method or endpoint.'}
  </EmptyStateGenerator>
);
